import React from 'react';
import ClientDepartmentDetail from '../../Editors/ClientDepartmentDetail';




const MoveClientToDepartment = () => <React.Fragment>
    <ClientDepartmentDetail/>
</React.Fragment>


export default MoveClientToDepartment;